module.exports = __webpack_public_path__ + "img/icon7.255542fc.svg";